import React from "react"
import Error from "next/error"
// TODO: Should be removed and replaced by a call to nodeApiService for artworksfilters
import galleryApiService from "../../../../services/galleryApiService"
import nodeApiService from "../../../../services/nodeApiService"
import Collection from "../../../../features/pages/CollectionPage"
import { idExtractor } from "../../../../services/utils/idExtractor"

const Collections = ({
  gallery,
  catalog,
  collection,
  filters,
  errorCode,
  errorMessage,
}) => {
  if (errorCode) {
    return <Error statusCode={errorCode} title={errorMessage} />
  }
  return (
    <Collection
      catalog={catalog}
      gallery={gallery}
      filters={filters}
      collection={collection}
    />
  )
}

export const getServerSideProps = async ({ params }) => {
  try {
    const { id, collection } = params

    // If given an ID find the domain and redirect
    const isNumericId = /^\d+$/.test(id)
    if (isNumericId) {
      const response = await galleryApiService
        .gallery(id)
        .catch((err) => err.response)
      if (!response || response.status !== 200) {
        return { notFound: true }
      }
      return {
        redirect: {
          destination: `/galleries/${
            response.data.domain
          }/collections/${encodeURIComponent(collection)}`,
          permanent: true,
        },
      }
    }

    const response = await galleryApiService
      .galleryByDomain(id)
      .catch((err) => err.response)
    const artworksResponse = await nodeApiService.galleryArtworksByCollection(
      response.data.id,
      collection,
    )

    // TODO: Should be moved to nodeApiService here and elsewhere in pages.
    const filterResponse = await galleryApiService.artworksfilters()
    return {
      props: {
        gallery: response.data,
        catalog: artworksResponse.data,
        collection,
        filters: filterResponse.data,
      },
    }
  } catch (error) {
    return {
      props: {
        errorCode: error.response.status,
        errorMessage: "Something went wrong",
      },
    }
  }
}

export default Collections
